import { createRouter, createWebHistory } from "vue-router";
import AdminLayout from "../layout/AdminLayout.vue";

const routes = [
    { path: "/login", component: () => import("../views/login/Login.vue"), meta: { public: true } },

    {
        path: "/",
        component: AdminLayout,
        redirect: "/dashboard",
        children: [
            { path: "dashboard", component: () => import("../views/dashboard/Dashboard.vue") },
            { path: "banner", component: () => import("../views/banner/BannerList.vue") },
            { path: "category", component: () => import("../views/category/CategoryList.vue") },
            { path: "product", component: () => import("../views/product/ProductList.vue") },
            { path: "user", component: () => import("../views/user/UserList.vue") },
            { path: "agent", component: () => import("../views/agent/AgentList.vue") },
            { path: "order", component: () => import("../views/order/OrderList.vue") },
            { path: "commission", component: () => import("../views/commission/CommissionList.vue") },
            {
                path: "/product/create",
                name: "ProductCreate",
                component: () => import("../views/product/ProductCreate.vue")
            },
            {
                path: '/product/edit/:id',
                name: 'ProductEdit',
                component: () => import("../views/product/ProductEdit.vue"),
                props: true, // 传递 `id` 参数
            },

        ]
    }
];

export default createRouter({
    history: createWebHistory(),
    routes
});
